<!--
 * @Author: M.D.
 * @Date: 2020-01-16 15:50:28
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="pq-o-w">
    <div class="pq-w">
      <div class="pq-tip">微信或支付宝扫一扫付款</div>
      <div class="price">应付总额： ￥{{ orderInfo.fee }}</div>
      <div class="pq-qrcode-w">
        <div style="text-align: center">
          <canvas
            id="qr_canvas"
            style="height: 200px; width: 200px; display: block"
          ></canvas>
          <p v-html="payHtml"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api/api'
import QRCode from 'qrcode'

export default {
  props: {},
  data() {
    return {
      orderInfo: {},
      qrInfo: {},
      poll: true,
      interval: null,
      timeout: false,
      tip: '',
      payHtml: '',
    }
  },
  computed: {},
  created() {
    // this.pollOrderStas()
  },
  mounted() {},
  activated() {
    this.getPayInfo()
  },
  deactivated() {},
  watch: {},
  methods: {
    async getPayInfo() {
      //alert(this.$route.query.orderId)
      // this.orderNumber=this.$route.query.orderNumber
      const orderRe = await API.getOrderDetail({
        orderId: this.$route.query.orderId,
      })
      // alert(orderRe.data.result.status)
      if (orderRe.data.statusCode === '200') {
        this.orderInfo = orderRe.data.result
        if (this.orderInfo.status === 1 || this.orderInfo.status === 3) {
          this.$router.push({
            name: 'payResult',
            query: {
              payState: 1,
              orderNumber: this.orderInfo.orderNumber,
              goodsName: this.orderInfo.goodsName,
              qr: orderRe.data.result.qr || '',
              tip: this.$route.query.tip,
            },
          })
          return
        }

        //聚合支付，根据payUrl获取对应页面
        var payUrl = this.$route.query.payUrl
        if (payUrl == null) {
          //重新获取二维码
          const qrRe = await API.getPayQr({
            orderNumber: this.$route.query.orderNumber,
          })
          //this.drawQRCode(qrRe.data.result.qrCode)
          this.qrInfo = qrRe.data.result
          payUrl = qrRe.data.result.qrCode
        }

        setTimeout(() => {
          this.drawQRCode(payUrl)
        }, 300)
      }
    },

    drawQRCode(url) {
      var canvas = document.getElementById('qr_canvas')
      const vm = this
      QRCode.toCanvas(canvas, url, { width: 200 }, function (error) {
        if (error) {
          vm.$message({
            message: '二维码生成出错',
            type: 'warning',
          })
        }
      })
      //this.pollOrderStas()
      this.interval = setInterval(this.pollOrderStas, 1000 * 4) //轮询状态
    },

    async pollOrderStas() {
      if (this.$route.name !== 'payQRCode') {
        return
      }
      const res = await API.checkIsPay({
        state: 'TYPE2' + this.orderInfo.orderNumber,
      })
      //alert(res.data.statusCode)
      if (res.data.statusCode === '200') {
        // ：为200表示已支付，201继续轮询，301表示二维码失效
        clearInterval(this.interval)
        this.$router.push({
          name: 'payResult',
          query: {
            payState: 1,
            orderNumber: this.orderInfo.orderNumber,
            goodsName: this.orderInfo.goodsName,
            tip: res.data.message,
            qr: res.data.qr || '',
          },
        })
      } else if (res.data.statusCode === '201') {
        this.timeout = true
        // this.pollOrderStas()
      } else if (res.data.statusCode === '301') {
           clearInterval(this.interval)
        this.alertInfo()
      }
    },
    alertInfo() {
      this.$alert('二维码失效，请重新下单', '提示', {
        confirmButtonText: '确定',
        callback: (action) => {
          setTimeout(() => {
            this.$router.go(-1)
          }, 300)
        },
      })
    },
  },
  destroyed() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  beforeDestory() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  components: {},
}
</script>

<style lang="stylus">
.pq-o-w {
  min-height: 600px;
  background-color: #ffffff;
  center();

  .pq-w {
    .pq-tip {
      text-align: center;
      font-size: 18px;
    }

    .price {
      margin: 20px 0 30px;
      text-align: center;
      color: orange-color;
      font-size: 22px;
      font-weight: bold;
    }
  }
}
</style>
